import { render, staticRenderFns } from "./depamentDialog.vue?vue&type=template&id=2b7263d7&scoped=true&"
import script from "./depamentDialog.vue?vue&type=script&lang=js&"
export * from "./depamentDialog.vue?vue&type=script&lang=js&"
import style0 from "./depamentDialog.vue?vue&type=style&index=0&id=2b7263d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7263d7",
  null
  
)

export default component.exports